/* eslint-disable import/no-cycle */
import React from 'react';
import Row from '../../Row';
import { TableHeaderObject } from '../UserTable';

interface IColumnDisplayProps {
  visibleColumns: TableHeaderObject[];
  dataRow: any;
}

interface IUserTableRowProps extends IColumnDisplayProps {
  onClick?: () => void;
  isLoading?: boolean;
}

const UserTableRow: React.FC<IUserTableRowProps> = ({ visibleColumns, dataRow, ...rest }) => (
  <Row clickable {...rest}>
    {visibleColumns?.map((column: TableHeaderObject) => (
      <React.Fragment key={column.value}>{dataRow[column.value]?.renderComponent}</React.Fragment>
    ))}
  </Row>
);

export default UserTableRow;
